import React from "react";

interface InfoBoxProps {
  children: React.ReactNode;
  isDark: boolean;
  variant?: "success" | "info" | "warning" | "error";
  className?: string;
}

const InfoBox = ({ 
  children, 
  isDark, 
  variant = "success",
  className = ""
}: InfoBoxProps) => {
  
  const getVariantClasses = () => {
    const variants = {
      success: {
        border: "border-green-500",
        background: isDark ? "bg-green-900/10" : "bg-green-50"
      },
      info: {
        border: "border-blue-500",
        background: isDark ? "bg-blue-900/10" : "bg-blue-50"
      },
      warning: {
        border: "border-yellow-500",
        background: isDark ? "bg-yellow-900/10" : "bg-yellow-50"
      },
      error: {
        border: "border-red-500",
        background: isDark ? "bg-red-900/10" : "bg-red-50"
      }
    };
    
    return variants[variant];
  };

  const { border, background } = getVariantClasses();

  return (
    <div className={`flex items-start p-3 rounded-lg mb-4 border ${border} ${background} ${className}`}>
      {children}
    </div>
  );
};

export default InfoBox;